export const base = {
  'nav.features': 'Features',
  'nav.pricing': 'Price',
  'nav.security': 'Security',
  'nav.docs': 'Docs',
  'nav.contact': 'Contact us',
  'nav.start': 'Get started',
  'nav.login': 'Log in',
  'nav.language': 'Language',

  'hero.title1': 'Build quizzes effortlessly',
  'hero.title2': 'In just a few clicks',
  'hero.subtitle': 'Kuizy.ai lets educators create, publish and analyse exams instantly — multilingual with enterprise-grade security.',
  'hero.start': 'Get started',
  'hero.details': 'Learn more',

  'features.heading1': '5 key features you’ll love',
  'features.zap.title': 'Create quizzes instantly',
  'features.zap.desc': 'Drag-and-drop questions or let AI build a full quiz for you — answers included.',
  'features.lang.title': 'Multilingual ready',
  'features.lang.desc': 'Translate and generate quizzes in 20+ languages, from Thai and English to Japanese.',
  'features.secure.title': 'Enterprise-level security',
  'features.secure.desc': 'AES-256 encryption, MFA and full GDPR / PDPA compliance.',
  'features.chart.title': 'Real-time analytics',
  'features.chart.desc': 'Live dashboards reveal scores and insights with interactive charts.',
  'features.plug.title': 'Seamless integrations',
  'features.plug.desc': 'Plug-and-play API & Webhooks connect to your LMS, Slack and Google Classroom.',

  'pricing.heading': 'Choose the plan that fits you',
  'pricing.period': '/month',
  'pricing.free.title': 'Free',
  'pricing.free.feature1': 'Up to 3 quizzes',
  'pricing.free.feature2': 'Question bank up to 100 items',
  'pricing.free.feature3': 'Up to 50 test-takers',
  'pricing.free.feature4': 'Basic analytics',
  'pricing.pro.title': 'Pro',
  'pricing.pro.feature1': 'Unlimited quizzes',
  'pricing.pro.feature2': 'Question bank up to 2 500 items',
  'pricing.pro.feature3': 'Unlimited test-takers',
  'pricing.pro.feature4': 'Advanced analytics & export',
  'pricing.pro.feature5': 'Priority support',
  'pricing.ent.title': 'Enterprise',
  'pricing.ent.feature1': 'All Pro features',
  'pricing.ent.feature2': 'Scalable question bank',
  'pricing.ent.feature3': 'Full backup & 99.9 % SLA',
  'pricing.ent.feature4': 'Comprehensive API & Webhooks',
  'pricing.ent.feature5': 'Dedicated customer-success team',
  'pricing.cta.pro': 'Upgrade to Pro',
  'pricing.cta.start': 'Start for ',

  'security.heading': 'Enterprise-grade security',
  'security.card1.title': 'AES-256 Encryption',
  'security.card1.desc': 'Bank-level encryption protects exams and results end-to-end.',
  'security.card2.title': 'Multi-factor authentication',
  'security.card2.desc': 'Secure accounts with OTP or authenticator apps.',
  'security.card3.title': 'GDPR & PDPA compliant',
  'security.card3.desc': 'Meets EU and TH data-protection laws with transparent user controls.',

  'docs.heading': 'Getting started is easy',
  'docs.video.title': '2-minute intro video',
  'docs.video.desc': 'A quick tour showing how to build and share a quiz.',
  'docs.wizard.title': 'Quick-start wizard',
  'docs.wizard.desc': 'Pick a topic, set options, publish — no manual needed.',
  'docs.manual.title': 'Full user guide',
  'docs.manual.desc': 'Detailed reference available after sign-in.',
  'docs.cta.try': 'Try it now',
  'docs.cta.login': 'Sign up / Log in',

  'testimonials.heading': 'What our users say',
  'testi.1.name': 'Mr Thanapon',
  'testi.1.role': 'Teacher, Suankularb School',
  'testi.1.text': 'Kuizy.ai lets me create online exams much faster. Students love the UI and I get instant insights.',
  'testi.2.name': 'Dr Suchada',
  'testi.2.role': 'Chiang Mai University',
  'testi.2.text': 'Secure and bilingual, perfect for our international programmes.',
  'testi.3.name': 'Vichai',
  'testi.3.role': 'HR Manager, BKK Corp',
  'testi.3.text': 'Great for onboarding assessments — saves time and delivers clear analytics.',

  'contact.heading': 'Contact us',
  'contact.address.title': 'Address',
  'contact.address.text': '21 Prasert-Manukitch 29 Yaek 7, Lat Phrao, Bangkok 10230',
  'contact.email.title': 'Email',
  'contact.phone.title': 'Phone',
  'contact.form.name': 'Your name',
  'contact.form.placeholder.name': 'Full name',
  'contact.form.email': 'Email',
  'contact.form.placeholder.email': 'you@example.com',
  'contact.form.msg': 'Message',
  'contact.form.placeholder.msg': 'Type your message here…',
  'contact.form.submit': 'Send message',

  'footer.privacy': 'Privacy Policy',
  'footer.cookie': 'Cookie Policy',
  'footer.terms': 'Terms of Service',
  'footer.contact': 'Contact us',
  'footer.copyright': 'All rights reserved',

  'cookie.title': 'We use cookies',
  'cookie.notice': 'We use essential cookies for site functionality and optional cookies for analytics and marketing. Essential cookies are always on. For others, please choose.',
  'cookie.link.privacy': 'Privacy Policy',
  'cookie.link.cookie': 'Cookie Policy',
  'cookie.btn.reject': 'Reject',
  'cookie.btn.manage': 'Manage',
  'cookie.btn.accept': 'Accept',
  'cookie.pref.title': 'Cookie preferences',
  'cookie.pref.essential': 'Essential (Always active)',
  'cookie.pref.functional': 'Functional',
  'cookie.pref.analytics': 'Analytics',
  'cookie.pref.marketing': 'Marketing',
  'cookie.pref.save': 'Save',
  'cookie.pref.cancel': 'Cancel',
}
